import { Directive, EventEmitter, HostListener, Input, Output } from '@angular/core';

@Directive({
  selector: '[trigger-on-click]',
  standalone: false,
})
export class TriggerOnClicksDirective {
  count = 0;

  @Input() triggerCount = 8;
  @Output() trigger = new EventEmitter<void>();

  @HostListener('click', ['$event'])
  public onClick(event: any): void {
    event.stopPropagation();
    if (this.count < this.triggerCount) {
      this.count += 1;
    } else {
      this.trigger.next();
      this.count = 0;
    }
  }
}
